module.exports = __webpack_public_path__ + "img/5.cf436a18.gif";